import { t } from '@unistocks/localization';
import { SelectOption } from '@unistocks/types';

export const currencyValueFormatter = (currency: string) =>
  `${t(`::Currency:${currency}`)} (${currency})`;

export const currencyTypeaheadFilter = <T = string>(
  text: string,
  currencies: ReadonlyArray<SelectOption<T>>
) =>
  currencies.filter(
    currency =>
      currency.key.toLowerCase().includes(text.toLowerCase()) ||
      String(currency.value).toLowerCase().includes(text.toLowerCase())
  );
